const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1', '::1', '[::1]']);

export function canUseDebugFixtureImport(dev: boolean, hostname: string): boolean {
  return dev && LOOPBACK_HOSTS.has(hostname.toLowerCase());
}

export function resolveDebugApiOrigin(
  configuredOrigin: string,
  pageOrigin: string = window.location.origin,
): string {
  const candidate = configuredOrigin.trim() === '' ? pageOrigin : configuredOrigin.trim();
  const url = new URL(candidate, pageOrigin);
  if (
    !['http:', 'https:'].includes(url.protocol) ||
    !LOOPBACK_HOSTS.has(url.hostname.toLowerCase()) ||
    url.username !== '' ||
    url.password !== '' ||
    (url.pathname !== '' && url.pathname !== '/') ||
    url.search !== '' ||
    url.hash !== ''
  ) {
    throw new Error('Das lokale Debug-API-Ziel ist nicht zulässig.');
  }
  return url.origin;
}
